import styled from "styled-components";
import colours from "styles/colours";
import shadows from "styles/shadows";

export const PanelContainer = styled.div<{
  $colour?: string;
}>`
  background-color: ${colours.white};

  border-top: 1px solid
    ${({ $colour }): string => $colour ?? colours.elexonBlue};

  &.mini-tile {
    border-top: none;
    border-left: 1px solid ${colours.elexonBlue};
    box-shadow: ${shadows.shadowMd};
  }

  &.mini-tile.summary-tile {
    padding: 1rem;
  }
`;
